import * as React from 'react'

export default props => (
  <svg width={16} height={16} viewBox="0 0 100 100" {...props}>
    <polygon points="50 0,0 50,100 50" {...props} />
  </svg>
)
